import {firebaseApp} from "../config/firebase"
import { getFirestore, doc, onSnapshot, setDoc, getDoc, getDocs, query, collection, where, serverTimestamp, limit} from "firebase/firestore"
import {getStorage} from "firebase/storage"
import { logError } from "../utils/errorHandlingUtils"
import { firebaseFetch, deleteImages, uploadImage } from "../utils/firebase"
// import { PAGINATE_NEXT, PAGINATE_BACK } from "../constants/interaction"

export const SAVE_PAYEE_PRODUCTS = 'SAVE_PAYEE_PRODUCTS'
export const CREATE_PAYEE_PRODUCT = 'CREATE_PAYEE_PRODUCT'
export const UPDATE_PAYEE_PRODUCTS = 'UPDATE_PAYEE_PRODUCT'

export const savePayeeProducts = payeeProducts => {
    return {
        type: SAVE_PAYEE_PRODUCTS,
        payload: {
            payeeProducts
        }
    }
}

export const createPayeeProduct = payeeProduct => {
    return {
        type: CREATE_PAYEE_PRODUCT,
        payload: {
            payeeProduct
        }
    }
}

export const updatePayeeProducts = (payeeProductId, update={}) => {
    return {
        type: UPDATE_PAYEE_PRODUCTS,
        payload: {
            payeeProductId,
            update
        }
    }
}


export const fetchSubscribeToPayeeProduct = (payeeProductId, onLoad=()=>{}) => {
    /**
      * Purpose: retrieve one payee product from the firestore database
      * Note: the onSnapshot below watches for changes to the payee product on the server
      */
    const firestore = getFirestore(firebaseApp)
    const payeeProductRef = doc(firestore, "payeeProducts", payeeProductId)
    
    return async (dispatch) => {
        try {
            const payeeProductListener = onSnapshot(payeeProductRef, (docSnap) => {
                console.log("Snapshot fired!");
                if (!docSnap.exists()) {
                    onLoad()
                    console.log("Document does not exist.");
                    return;
                }
                console.log("in payeeProductListener")
                console.log("Document data:", docSnap.data());
                //get one payee product from the snapshot
                const payeeProduct = {...docSnap.data()}
                dispatch(savePayeeProducts([payeeProduct]))
                onLoad(payeeProduct)
            }
            , 
            (error) => {
                console.error("Firestore error:", error);
            }
            );
            return payeeProductListener
        } catch (e){
            const message = `action > payeeProducts > fetchSubscribeToPayeeProducts: Failed to subscribe to payee product`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return () => {}
        }
    }
}

export const fetchSubscribeToPayeeProductByHandleId = (
    payeeProductHandleId = "",
    payeeId = "",
    onLoad = () => {
    }
) => {
    /**
     * Purpose: retrieve one payee product via its handleId from the firestore database
     * Note: the onSnapshot below watches for changes on the server
     */
    if (!payeeProductHandleId || !payeeId) return () => {
    }
    const firestore = getFirestore(firebaseApp)
    const payeeProductsRef = query(collection(firestore, "payeeProducts"), 
                                where("handleId", "==", payeeProductHandleId),
                                where("payeeId", "==", payeeId),
                                where("deleted", "==", false),
                                limit(1)
                                )
    return async dispatch => {
        try {
            const payeeProductsListener = await onSnapshot(payeeProductsRef, 
                querySnapshot => {
                    //get an array of payee products from the snapshot
                    const payeeProducts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
                    dispatch(savePayeeProducts(payeeProducts))
                    onLoad()
                } )
            return payeeProductsListener
        } catch (e) {
            const message = `action > payeeProducts > fetchSubscribeToPayeeProductByHandleId: Failed to save payee product with handle ${payeeProductHandleId} from payee ${payeeId}`
            if (e.message_) {
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return () => {
            }
        }
    }
}

export const httpFetchSavePayeeProductByHandleId = (
    payeeProductHandleId = "",
    payeeId = "",
    onLoad = () => {
    }
) => {
    /**
     * Purpose: retrieve one payee product via its handleId from the firestore database
     */
     console.time(`httpFetchSavePayeeProductByHandleId ${payeeProductHandleId}`)
    if (!payeeProductHandleId || !payeeId) return false
    return async dispatch => {
        try {
            const payeeProducts = await firebaseFetch(
                "payeeProducts", 
                [
                    ["handleId", "==", payeeProductHandleId],
                    ["payeeId", "==", payeeId],
                    ["deleted", "==", false]
                ],
                {limit: 1}
            )
            console.timeEnd(`httpFetchSavePayeeProductByHandleId ${payeeProductHandleId}`)
            dispatch(savePayeeProducts(payeeProducts))
            onLoad()
            return true
        } catch (e) {
            const message = `action > payeeProducts > httpFetchSavePayeeProductByHandleId: Failed to save payee product with handle ${payeeProductHandleId} from payee ${payeeId}`
            if (e.message_) {
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSavePayeeProductsForPayee = (
    payeeId,
 ) => {
    const firestore = getFirestore(firebaseApp)
    const payeeProductsRef = query(
                            collection(firestore, "payeeProducts"), 
                            where("payeeId", "==", payeeId)
                        )
    return async (dispatch) => {
        try{
            const querySnapshot = await getDocs(payeeProductsRef)
            //get an array of payee activity objects from the snapshot
            const payeeProducts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
            dispatch(savePayeeProducts(payeeProducts))
            return true
        } catch (e){
            const message = `action > payeeProducts > fetchSavePayeeProductsForPayee: Failed to save payee products for ${payeeId}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSubscribeToPayeeProductsForPayee = (
    payeeId,
 ) => {
    const firestore = getFirestore(firebaseApp)
    const payeeProductsRef = query(
                            collection(firestore, "payeeProducts"), 
                            where("payeeId", "==", payeeId), 
                        )
    return async (dispatch) => {
        try{
            const payeeProductsListener = await onSnapshot(payeeProductsRef,
                querySnapshot =>{
                    //get an array of payee products from the snapshot
                    const payeeProducts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
                    dispatch(savePayeeProducts(payeeProducts))
                }
            )
            return payeeProductsListener
        } catch (e){
            const message = `action > payeeProducts > fetchSubscribeToPayeeProductsForPayee: Failed to subscribe to payeeProducts for ${payeeId}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return () => {}
        }
    }
}

export const httpFetchSavePayeeProductsForPayeeCatalog = (
    payeeCatalogId,
 ) => {
    console.time(`httpFetchSavePayeeProductsForPayeeCatalog ${payeeCatalogId}`)
     if (!payeeCatalogId) return false
    return async (dispatch) => {
        try{
            const payeeProducts = await firebaseFetch(
                "payeeProducts", 
                [
                    ["payeeCatalogIds", "array-contains",  payeeCatalogId]
                ],
            )
            console.timeEnd(`httpFetchSavePayeeProductsForPayeeCatalog ${payeeCatalogId}`)
            dispatch(savePayeeProducts(payeeProducts))
            return true
        } catch (e){
            const message = `action > payeeProducts > httpFetchSavePayeeProductsForPayeeCatalog: Failed to save to payeeProducts for payee catalog ${payeeCatalogId}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSubscribeToPayeeProductsForPayeeCatalog = (
    payeeCatalogId,
 ) => {
    const firestore = getFirestore(firebaseApp)
    const payeeProductsRef = query(
                            collection(firestore, "payeeProducts"), 
                            where("payeeCatalogIds", "array-contains", payeeCatalogId), 
                        )
    return async (dispatch) => {
        try{
            const payeeProductsListener = await onSnapshot(payeeProductsRef,
                querySnapshot =>{
                    //get an array of payee products from the snapshot
                    const payeeProducts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
                    dispatch(savePayeeProducts(payeeProducts))
                }
            )
            return payeeProductsListener
        } catch (e){
            const message = `action > payeeProducts > fetchSubscribeToPayeeProductsForPayeeCatalog: Failed to subscribe to payeeProducts for payee catalog ${payeeCatalogId}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return () => {}
        }
    }
}

export const fetchCreatePayeeProduct = (
    id,
    payeeId,
    name,
    handleId,
    productType,
    price,
    description,
    defaultVariantId,
    hasVariants,
    variantsById,
    isInactive,
    onSuccess=()=>{}, 
    onError=()=>{}
) => {
    const firestore = getFirestore(firebaseApp);
    const payeeProductsRef = doc(firestore, "payeeProducts", id)
    const payeeProduct = {
        id,
        payeeId,
        name,
        handleId,
        productType,
        price,
        description,
        defaultVariantId,
        hasVariants,
        variantsById,
        isInactive,
        createdAt: Date.now(),
        createdAtTimestamp: serverTimestamp(),
        deleted: false
    }
    return async (dispatch, getState) => {
        try{
            const {user} = getState()
            const storage = getStorage(firebaseApp)
            //loop through each variant and upload each of it's images
            for (let variantId in variantsById) {  
                const variant = {...variantsById[variantId]}
                const {images} = variant
                //upload a small, med and large image for each image in the images array
                variant.images = await uploadVariantImages(storage, images, payeeId, id, variantId) 
                //if this is the default varaint, set the product imageUrl to the first image in the images array
                if (defaultVariantId === variantId){
                    payeeProduct.imageUrl = variant.images[0].med
                }
                variantsById[variantId] = variant
            }
            payeeProduct.createdByUserId = user.id ? user.id : null
            await setDoc(payeeProductsRef, payeeProduct)
            dispatch(createPayeeProduct(payeeProduct))
            onSuccess(payeeProduct)
            return true
        } catch (e){
            const message = `action > payeeProducts > fetchCreatePayeeProduct: Failed to create payee product ${JSON.stringify(payeeProduct)}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            onError(payeeProduct)
            return false
        }
        
    }
}

const uploadVariantImages = async (storage, images=[], payeeId, payeeProductId, variantId) => {
    /**
     * Purpose: upload the variant images to storage
     * 
     * Approach:
     * 
     * For each image
     * 1. check whether the image includes a "file" key, this is the flag that signals a change in photo
     * 2. construct the image path 
     * . shrink the file size 3 times to make a small and medium version
     * 3. upload the 3 files to storage
     * 4. set the small, med and large keys on the image object
     */
    images = [...images]
    await Promise.all(images.map(async (image, i) => {
        //having the file key signals the need to upload
        //image objects without it already have their images uploaded on the server
        if (image.file){
            const {file} = image
            const imagePath = `payee-products/${payeeId}/${payeeProductId}/${variantId}/${i}`
            const newImage = await uploadImage(storage, file, imagePath)
            images[i] = newImage
        } 
    }))
    return images
} 

export const fetchUpdatePayeeProduct = (
    id,
    update={},
    onSuccess=()=>{},
    onError=()=>{}
 ) => {
    const firestore = getFirestore(firebaseApp)
    const payeeProductsRef = doc(firestore, "payeeProducts", id)
    return async (dispatch, getState) => {
        try{
            const {user, payeeProducts} = getState()
            const previousPayeeProduct = payeeProducts.payeeProductsById[id]
            
            /** HANDLE CHANGES IN VARIANTS - START */
            //if the variants are being updated, then the images could have been changed, in which case we must
            //1. delete from storage, the images that have been removed and
            //2. upload to storage, the images that have been added
            //3. update the default product imageUrl if it has been changed
            const {variantsById} = update
            if (variantsById){
                const storage = getStorage(firebaseApp)
                const defaultVariantId = update.defaultVariantId ? update.defaultVariantId : previousPayeeProduct.defaultVariantId
                const defaultVariant = variantsById[defaultVariantId]
                if (!defaultVariant) throw new Error("Default variant not found")
                //if the product's variants have been changed
                /**1. delete from the server any removed images**/

                //1(a). get all of the current images, so we can check whether the previous images are in there 
                const currentImagesMap = Object.values(variantsById).reduce((imageMap, variant) => {
                    const {images=[]} = variant
                    images.forEach(image => {imageMap[image.med] = image})
                    return imageMap
                }, {})
                //1(b). detect whether a previously existing image has been deleted, by checking whether it is in the list of current images
                const deletedImages = Object.values(previousPayeeProduct.variantsById).reduce((deletedImages, previousVariant) => {
                    const {images: previousImages=[]} = previousVariant
                    deletedImages = [
                        ...deletedImages, 
                        //add any images that cannot be found in the map of currently existing images
                        ...previousImages.filter(image => !currentImagesMap[image.med])
                    ]
                    return deletedImages
                }, [])
                //1(c). delete the urls of each of the images from storage
                await deleteImages(storage, deletedImages)
                /**2. upload to storage, the images that have been added**/
                for (let variantId in variantsById) {  
                    const variant = {...variantsById[variantId]}
                    const {images} = variant
                    //uploadVariantImages detects any images that need to by uploaded and
                    //uploads a small, med and large image for each image in the images array
                    //then it replaces the local urls for that image with the remote storage urls
                    //it skips, and leaves in place in the array, any images that do not need to be uploaded (those needing upload have a file key)
                    variant.images = await uploadVariantImages(storage, images, previousPayeeProduct.payeeId, id, variantId) 
                    //3. update the default product imageUrl if it has been changed
                    if (defaultVariantId === variantId){
                        update.imageUrl = variant.images[0].med
                    }
                    update.variantsById[variantId] = variant
                }
            }
            /** HANDLE CHANGES IN VARIANTS - END */
            update.lastUpdatedByUserId = user.id
            update.lastUpdatedAt = Date.now()
            update.lastUpdatedAtTimestamp = serverTimestamp()
            await setDoc(payeeProductsRef, {
                ...previousPayeeProduct,
                ...update
            })
            dispatch(updatePayeeProducts(id, update))
            onSuccess(update)
            return true
        } catch (e){
            const message = `action > payeeProducts > fetchUpdatePayeeProduct: Failed to update payment product ${id} with update ${JSON.stringify(update)}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            onError(update)
            return false
        }
    }
}

export const fetchDeletePayeeProduct = (
    id,
    onSuccess=()=>{},
    onError=()=>{}
 ) => {
    const firestore = getFirestore(firebaseApp)
    const payeeProductsRef = doc(firestore, "payeeProducts", id)
    return async (dispatch, getState) => {
        try{
            const {user, payeeProducts} = getState()
            const payeeProduct = payeeProducts.payeeProductsById[id]
            if (!payeeProduct) throw new Error(`Could not find payee product in redux for id ${id}`)
            //1. delete all of the product variant images storage
            //2. soft delete the product by updating deleted=true
            const {variantsById} = payeeProduct
            const storage = getStorage(firebaseApp)
            /**1. delete from the server any removed images**/

            //1(a). get all of the current images, from each variant in the product 
            const imagesToDelete = Object.values(variantsById).reduce((imagesToDelete, variant) => {
                const {images=[]} = variant
                imagesToDelete = [...imagesToDelete, ...images]
                return imagesToDelete
            }, [])
            //1(c). delete the urls of each of the images from storage
            await deleteImages(storage, imagesToDelete)

            /**1. soft delete the product by updating deleted=true**/
            const update = {deleted: true}
            update.deletedByUserId = user.id
            update.deletedAt = Date.now()
            update.deletedAtTimestamp = serverTimestamp()
            await setDoc(payeeProductsRef, {
                ...payeeProduct,
                ...update
            })
            dispatch(updatePayeeProducts(id, update))
            onSuccess(update)
            return true
        } catch (e){
            const message = `action > payeeProducts > fetchDeletePayeeProduct: Failed to delete payee product ${id}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            onError()
            return false
        }
    }
}

export const fetchConfirmPayeeProductHandleIdUnique = (
    handleId,
    payeeId,
    onSuccess=()=>{},
    onError=()=>{}
) => {
    const firestore = getFirestore(firebaseApp)
    const payeeProductHandleRef = doc(firestore, `payees/${payeeId}/payeeProductHandles`, handleId)
    return async () => {
        try {
            const payeeProductHandleDocRef = await getDoc(payeeProductHandleRef)
            return !payeeProductHandleDocRef.exists()
        } catch (e) {
            e.message = `${e.message} action > payees > fetchConfirmPayeeProductHandleIdUnique: Failed to confirm handle ${handleId} is unique`
            logError(e)
            onError(e)
            return false
        }
    }
}